<template>
  <!-- ページ内容 -->
  <div class="l-page l-page--option">
    <!-- サイドバーエリア -->
    <page-sidebar />
    <!-- /サイドバーエリア -->

    <!-- メインコンテンツエリア -->
    <main class="l-main">
      <div class="l-main-content">
        <div class="p-option-service">
          <h2 class="c-title">
            <div class="c-title__text">オプションサービス</div>
          </h2>
          <div class="p-option-readme">
            <div class="p-option-readme__content">
              <h2 class="c-title">
                <div class="c-title__text c-title__text--blue">
                  DMP連携セグメント配信
                </div>
              </h2>
              <div class="c-text">
                オーディエンスデータと連携を行い、オプトインユーザーに属性を付与。御社DMPとの連携無しで性別、年代、地域によりセグメント配信が可能になり、非会員ユーザーでも属性別にリーチが行えます。<br />
                オーディエンスデータは、ログリー株式会社提供のJuicerと連携しています。
              </div>
            </div>
            <div class="c-image">
              <img src="/assets/img/sketch-option-01.svg" />
            </div>
          </div>
          <div class="p-option-juicer">
            <h3 class="c-title">
              <div class="c-image">
                <img src="/assets/img/logo-juicer.png" />
              </div>
              <div class="c-title__text">
                とは、、ビックデータ×人工知能を利用した、無料のユーザー分析DMPです。
              </div>
            </h3>
            <ul class="p-option-juicer-screen-list">
              <li class="p-option-juicer-screen-list__item">
                <div class="c-text">
                  あなたのサイトの<br />ペルソナを自動で作成
                </div>
                <div class="c-image">
                  <img src="/assets/img/capture-juicer-01.png" />
                </div>
              </li>
              <li class="p-option-juicer-screen-list__item">
                <div class="c-text">
                  たった一つの設問で<br />ロイヤルユーザーや反逆者が分かる。
                </div>
                <div class="c-image">
                  <img src="/assets/img/capture-juicer-02.png" />
                </div>
              </li>
              <li class="p-option-juicer-screen-list__item">
                <div class="c-text">
                  かんたん操作でサイトの<br />コンバージョンを平均163%改善!
                </div>
                <div class="c-image">
                  <img src="/assets/img/capture-juicer-03.png" />
                </div>
              </li>
            </ul>
            <ul class="p-option-juicer-function-list">
              <li class="p-option-juicer-function-list__item">
                <div class="c-image">
                  <img src="/assets/img/function-juicer-01.png" />
                </div>
                <div class="c-text">ポップアップバナー</div>
              </li>
              <li class="p-option-juicer-function-list__item">
                <div class="c-image">
                  <img src="/assets/img/function-juicer-02.png" />
                </div>
                <div class="c-text">ユーザー分析</div>
              </li>
              <li class="p-option-juicer-function-list__item">
                <div class="c-image">
                  <img src="/assets/img/function-juicer-03.png" />
                </div>
                <div class="c-text">アクセスログ分析</div>
              </li>
              <li class="p-option-juicer-function-list__item">
                <div class="c-image">
                  <img src="/assets/img/function-juicer-04.png" />
                </div>
                <div class="c-text">BtoB分析</div>
              </li>
              <li class="p-option-juicer-function-list__item">
                <div class="c-image">
                  <img src="/assets/img/function-juicer-05.png" />
                </div>
                <div class="c-text">リードスコアリング</div>
              </li>
            </ul>
            <div class="p-option-juicer-official">
              <div class="c-text">
                <a href="https://juicer.cc/" rel="noopener noreferrer" target="_blank">Juicerオフィシャルサイトはこちら</a>
              </div>
            </div>
          </div>
        </div>
        <!-- <option-how-to></option-how-to> -->
        <div class="p-option-btns">
          <button
            class="c-btn c-btn--modal c-btn--blue u-w358 u-h50 u-fs--l"
            type="button"
            name="edit"
            value="edit"
            @click="onContactClick"
          >
            <p class="c-btn__text">お問い合わせ</p>
          </button>
        </div>

      </div>
    </main>
    <!-- /メインコンテンツエリア -->
  </div>
<!-- /ページ内容 -->
</template>

<script>
export default {
  props: {
    contactUrl: String,
  },
  methods: {
    onContactClick: function (event) {
      event.preventDefault();
      location.href = this.contactUrl;
    },
  },

};
</script>
